import { Link } from '@tanstack/react-router'
import type { NotFoundRouteProps } from '@tanstack/react-router'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { Button } from '@/components/ui/button'

function NotFoundCard() {
  return (
    <div className="glass-panel w-full max-w-xl rounded-3xl border border-[var(--color-border)] p-8 text-center space-y-4">
      <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[var(--color-bg-tertiary)]">
        <span className="material-symbols-outlined text-2xl text-[var(--color-text-secondary)]">
          search_off
        </span>
      </div>

      <div className="space-y-2">
        <h1 className="text-2xl font-bold text-[var(--color-text-primary)]">
          Page not found
        </h1>
        <p className="text-sm text-[var(--color-text-tertiary)]">
          The page you’re looking for doesn’t exist or may have moved.
        </p>
      </div>

      <div className="pt-1">
        <Button variant="primary" asChild>
          <Link to="/">Go Home</Link>
        </Button>
      </div>
    </div>
  )
}

/** 404 body only, for routes nested in a layout that already renders the
 * site Header/Footer (e.g. /blogs/$slug inside BlogLayout). */
export function NotFoundContent(_props: NotFoundRouteProps) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-12">
      <NotFoundCard />
    </div>
  )
}

/** Full-page 404 with the standard site chrome. Each public route renders its
 * own Header/Footer (there is no shared layout route), so a notFoundComponent
 * that replaces a route's component has to render them itself. */
export function AppNotFoundPage(_props: NotFoundRouteProps) {
  return (
    <div className="relative min-h-screen flex flex-col overflow-x-hidden bg-[var(--color-bg-primary)]">
      <Header />
      {/* pt-16 clears the fixed h-16 header, so the card centers in the
          visible area below it rather than in the full viewport. */}
      <main className="flex min-h-screen items-center justify-center px-4 pt-16 pb-12">
        <NotFoundCard />
      </main>
      <Footer />
    </div>
  )
}
